import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';
export const useStyles = makeStyles(
  (theme) => ({
    listItemSub: {
      height: 'unset',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-evenly',
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.gray.gray50,
      gap: theme.spacing(0.5),
      '& p': {
        width: '100%',
      },
      padding: theme.spacing(1.5, 1),
    },
    listItemSubImage: {
      padding: 0,
      '& p': {
        maxWidth: 120,
        width: '100%',
        textAlign: 'center',
      },
      '&:hover': {
        backgroundColor: 'unset',
      },
    },
    listItemSubNoHover: {
      '&:hover': {
        backgroundColor: 'unset',
        cursor: 'default',
      },
    },
    emptyState: {
      padding: theme.spacing(0, 2, 0),
      minHeight: 20,
      backgroundColor: 'unset',
      cursor: 'default',
      '&:hover, &$selected': {
        backgroundColor: 'unset',
      },
      '& > p': {
        fontSize: theme.typography.pxToRem(12),
        lineHeight: theme.typography.pxToRem(20),
        color: COLORS.neutral.mediumGray,
      },
    },

    title: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(14),
      padding: theme.spacing(0, 0, 0, 1),
      backgroundColor: 'unset !important',
      minHeight: 20,
      cursor: 'default',
      '&:hover, &$selected': {
        backgroundColor: 'unset',
      },
      '&  p': {
        color: COLORS.gray.gray40,
        fontSize: theme.typography.pxToRem(12),
        lineHeight: theme.typography.pxToRem(14),
      },
    },

    createButton: {
      backgroundColor: 'unset',
      cursor: 'pointer',
      borderRadius: 0,
      marginBottom: theme.spacing(1.25),
      paddingTop: 0,
      borderBottom: theme.shape.borderGray70,
      '&:hover, &$selected': {
        backgroundColor: 'unset',
        textDecoration: 'underline',
      },

      '& > p': {
        marginBottom: theme.spacing(0.5),
        color: COLORS.primary.active,
        '&:hover, &$selected': {
          textDecoration: 'underline',
        },
      },
      '&:last-child': {
        border: 'none',
        marginBottom: 0,
        paddingBottom: 0,
      },
    },
    menuIcon: {
      display: 'flex',
      width: '100%',
    },
    iconWrapper: {
      paddingRight: theme.spacing(1),
    },
    assetIcon: {
      color: COLORS.gray.gray30,
      fontSize: theme.typography.pxToRem(20),
    },
    resourceItem: { textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' },
    label: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.gray.black,
      fontWeight: theme.typography.fontWeightMedium,
    },
    itemContent: {
      marginTop: theme.spacing(0.25),
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    body: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
    },
    labelImage: {
      marginTop: theme.spacing(1),
      fontWeight: 'unset',
    },
    image: {
      position: 'relative',
      width: 120,
      height: 100,
      '&:hover': {
        filter: 'contrast(60%)',
      },
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundSize: 'cover',
      borderRadius: theme.shape.borderRadiusSmall,
    },
    documentTooltip: {
      width: 190,
      maxHeight: 215,
    },
  }),
  { name: 'PromptMenuItem' }
);
